import { memo } from 'react'
import { useParams } from 'react-router-dom'

import PageTabs from '@app/shared/pageTabs'
import type { TabsType } from '@app/types'

const Index = () => {
  const { '*': tab } = useParams()

  const tabs: TabsType = {}
  tabs.details = { to: 'details' }

  return <PageTabs tab={tab} tabs={tabs} />
}

export default memo(Index)
